export default __webpack_public_path__ + "static/media/youtube.dd1d37f1.svg";